module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Ice-cream2-0974011ad5cf7b696026ee111898281c.svg";